// repo: https://vuemc.io/#basic-usage
import {Model, Collection} from 'vue-mc'
import isPresent from 'is-present'
import Moment from 'moment-timezone'

class RegistrationSectionOption extends Model {
  defaults() {
    return {
      id: null,
      price: {},
      section_option: {},
      registration: {},
      _destroy: false,
    }
  }

  mutations() {
    return {}
  }
}

export {
  RegistrationSectionOption
}